import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import registrationIcon from "@/assets/images/png/registration-now.png";


function RegistrationPopup(props) {
  return (
    <div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={props.smallmodalShow}
        onHide={() => props.setSmallModalShow(false)}
        className='registration-modal-contant outer-pages new-design'
      >
        <Modal.Header className='registration-modal-header'>
          {/* <Modal.Title id="contained-modal-title-vcenter" className='modal-title'>
            {props.title}
            <div className='iconwrape'>
              <img src={registrationIcon} alt="registration" className='icon' />
            </div>
          </Modal.Title> */}
          <div className="registor-arrow-down close-icon" onClick={() => props.setSmallModalShow(false)}></div>
        </Modal.Header>

        <Modal.Body className='registration-modal-body'>

          {props.children}

        </Modal.Body>

        {/* <Modal.Footer className='registration-modal-footer center'>

          {props.okButtonLabel && <Button
            type={props.type}
            onClick={props.onSubmit}
            className='btn btn-primary'

          >{props.okButtonLabel}</Button>

          }

        </Modal.Footer> */}

      </Modal>

    </div>
  )
}

export default React.memo(RegistrationPopup);
